import { useEffect, useState } from "react";
import axios from "axios";

function AssetImage({ imagePath, width = 80, height = 80 }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!imagePath) return;

    const token = sessionStorage.getItem("token"); 
    const controller = new AbortController();

    const loadImage = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}${imagePath}`, {
          headers: {
            Authorization: `Bearer ${token}`
           
          },
          responseType: "blob",
          signal: controller.signal,
        });

        const objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      } catch (e) {
        console.error("Image load failed:", e);
      }
    };

    loadImage();

    return () => {
      controller.abort();
      if (url) URL.revokeObjectURL(url);
    };
  }, [imagePath]);

  if (!url) {
    return (
      <div style={{ width, height, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span style={{ fontSize: 12, color: "#999" }}>Loading...</span>
      </div>
    );
  }

  return (
    <img
      src={url}
      alt="asset"
      style={{ width, height, objectFit: "contain" }}
    />
  );
}

export default AssetImage;